export default __webpack_public_path__ + "static/DINosaurKU-Book-a2997bf4222bd0063e56523e68629e50.woff";